import { render } from "./PurchaseDropdown.vue?vue&type=template&id=6523a6d4&scoped=true"
import script from "./PurchaseDropdown.vue?vue&type=script&lang=js"
export * from "./PurchaseDropdown.vue?vue&type=script&lang=js"

import "./PurchaseDropdown.vue?vue&type=style&index=0&id=6523a6d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6523a6d4"]])

export default __exports__